/* PDP "What you need to spray": the size select on a tip row (price, stock line and the id the + button adds follow the pick),
   the bundle buttons (data-bundle-add="id,id": one add of several lines) and Add all on the tip picks. */
(() => {
  const money = (c) => window.ASE.formatMoney(c);
  document.querySelectorAll('.need').forEach((row) => {
    const sel = row.querySelector('[data-size-select]');
    if (!sel) return;
    const sync = () => {
      const o = sel.selectedOptions[0];
      if (!o) return;
      const add = row.querySelector('[data-quick-add]');
      if (add) { add.dataset.quickAdd = o.value; if (o.dataset.label) add.setAttribute('aria-label', 'Add ' + o.dataset.label); }
      const pr = row.querySelector('[data-need-price]');
      if (pr) pr.textContent = money(Number(o.dataset.price));
      const st = row.querySelector('[data-need-stock]');
      if (st) st.innerHTML = o.dataset.stock || '';
    };
    sel.addEventListener('change', sync);
    sync();
  });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-bundle-add],[data-picks-all]');
    if (!b || !window.ASE || !ASE.addWithFeedback) return;
    const ids = (b.dataset.bundleAdd || b.dataset.picksAll).split(',').filter(Boolean);
    ASE.addWithFeedback(b, ids.map((id) => ({ id: Number(id), quantity: 1 })));
  });
})();
